import { render, staticRenderFns } from "./ProviderItem.vue?vue&type=template&id=da008a44&"
import script from "./ProviderItem.vue?vue&type=script&lang=js&"
export * from "./ProviderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports